// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quantity-selector {
  display: flex;
  font-size: calc(var(--quantity-selector-height) / 2);
}
.quantity-selector > * {
  line-height: var(--quantity-selector-height);
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: var(--quantity-selector-height);
  height: var(--quantity-selector-height);
  cursor: pointer;
  border-radius: 50%;
  color: var(--color-black);
}

.rectangle {
  background: transparent !important;
  color: var(--color-black);
  width: calc(1 * var(--quantity-selector-height));
  height: var(--quantity-selector-height);
  font-family: AppFont;
  font-size: var(--quantity-font-size);
  line-height: 28.8px;
  text-align: center;
}

ion-icon {
  height: 100%;
  width: 100%;
}
ion-icon:active {
  opacity: 0.6;
}

.cart-screen > * {
  background: #f1efea;
}`, "",{"version":3,"sources":["webpack://./src/app/components/quantity-selector/quantity-selector.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,oDAAA;AACD;AACC;EAEC,4CAAA;EACA,UAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AADF;;AAaA;EACC,sCAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AAVD;;AAaA;EACC,kCAAA;EACA,yBAAA;EACA,gDAAA;EACA,uCAAA;EAEA,oBAAA;EACA,oCAAA;EACA,mBAAA;EACA,kBAAA;AAXD;;AAcA;EACC,YAAA;EACA,WAAA;AAXD;AAaC;EACC,YAAA;AAXF;;AAgBC;EACC,mBAAA;AAbF","sourcesContent":[".quantity-selector {\n\tdisplay: flex;\n\tfont-size: calc(var(--quantity-selector-height) / 2);\n\n\t> * {\n\t\t// background: #c6aa7a;\n\t\tline-height: var(--quantity-selector-height);\n\t\tpadding: 0;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\t// &:first-child {\n\t\t// \tborder-left: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\n\t\t// &:last-child {\n\t\t// \tborder-right: var(--quantity-selector-border-width) var(--quantity-selector-border-color) solid;\n\t\t// }\n\t}\n}\n\n.circle {\n\twidth: var(--quantity-selector-height);\n\theight: var(--quantity-selector-height);\n\tcursor: pointer;\n\tborder-radius: 50%;\n\tcolor: var(--color-black);\n}\n\n.rectangle {\n\tbackground: transparent !important;\n\tcolor: var(--color-black);\n\twidth: calc(1 * var(--quantity-selector-height));\n\theight: var(--quantity-selector-height);\n\n\tfont-family: AppFont;\n\tfont-size: var(--quantity-font-size);\n\tline-height: 28.8px;\n\ttext-align: center;\n}\n\nion-icon {\n\theight: 100%;\n\twidth: 100%;\n\n\t&:active {\n\t\topacity: 0.6;\n\t}\n}\n\n.cart-screen {\n\t> * {\n\t\tbackground: #f1efea;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
